import { start } from "@popperjs/core";
import {
  DELETE_COMMENT,
  DELETE_POST,
  GET_COMMENT,
  GET_LIKE,
  GET_POST,
  GET_USER_PROFILE,
  INSERT_POST,
  UPDATE_USER_INFO,
  RESET_USER_IMAGE,
} from "./types";

const initialState = {
  post: [],
  comment: [],
  like: [],
  hashtag: [],
  caption: [],
  totalPost: 0,
  userProfile: {},
};

const postReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_POST:
      return {
        ...state,
        post: action.payload.post,
        totalPost: action.payload.total,
      };
    case GET_COMMENT:
      return {
        ...state,
        comment: action.payload,
      };
    case GET_LIKE:
      return {
        ...state,
        like: action.payload,
      };

    case DELETE_POST:
      return {
        ...state,
        post: state.post.filter((post) => post._id !== action.payload),
      };

    case DELETE_COMMENT:
      return {
        ...state,
        comment: state.comment.filter(
          (comment) => comment._id !== action.payload
        ),
      };

    case INSERT_POST:
      const data = [...state.post];
      data.unshift(action.payload);

      return {
        ...state,
        post: data,
        comment: action.payload,
        like: action.payload,
        hashtag: action.payload,
        caption: action.payload,
      };

    case GET_USER_PROFILE:
      return {
        ...state,
        userProfile: action.payload,
      };

    case UPDATE_USER_INFO :
      return {
        ...state,
        userProfile: { ...state.userProfile, ...action.payload },
      };

    case RESET_USER_IMAGE:
      return {
        ...state,
        userProfile: action.payload,
      }

    default:
      return state;
  }
};

export default postReducer;
